import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterTaskbarComponent } from './footer-taskbar/footer-taskbar.component';
import { FooterTaskpaneComponent } from './footer-taskpane/footer-taskpane.component';
import { TaskpaneRecentActivityComponent } from './taskpane-recent-activity/taskpane-recent-activity.component';
import { TaskpaneTileMenuComponent } from './taskpane-tile-menu/taskpane-tile-menu.component';
import { TaskpaneUserMenuComponent } from './taskpane-user-menu/taskpane-user-menu.component';
import { TaskbarTabsLeftComponent } from './taskbar-tabs-left/taskbar-tabs-left.component';
import { TaskbarTabsRightComponent } from './taskbar-tabs-right/taskbar-tabs-right.component';
import { TaskbarService } from './taskbar.service';
import { StatusBarRightComponent } from './status-bar-right/status-bar-right.component';

@NgModule({
    imports: [
      CommonModule
    ],
    declarations: [
        FooterTaskbarComponent,
        FooterTaskpaneComponent,
        TaskpaneRecentActivityComponent,
        TaskpaneTileMenuComponent,
        TaskpaneUserMenuComponent,
        TaskbarTabsLeftComponent,
        TaskbarTabsRightComponent,
        StatusBarRightComponent
    ],
    exports: [
        FooterTaskbarComponent,
        FooterTaskpaneComponent,
        TaskpaneRecentActivityComponent,
        TaskpaneTileMenuComponent,
        TaskpaneUserMenuComponent,
        TaskbarTabsLeftComponent,
        TaskbarTabsRightComponent,
        StatusBarRightComponent
    ],
    providers: [TaskbarService]
})
export class NgxUiFooterTaskbarModule { }
